module.exports = __webpack_public_path__ + "static/media/ic-no-results.2c352e86.svg";